<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <SkillcampContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import SkillcampContent from "~~/codepresso-renewal/content/SkillcampContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "SkillCamp — 짧고 강하게 몰입하는 오프라인 집체교육 | 코드프레소",
  meta: [
    { name: "description", content: "강사가 이끄는 집합·부트캠프 교육입니다. 실전 미션과 팀 프로젝트를 전문가 피드백으로 다듬으며 실전 역량을 끌어올립니다." },
    { name: "title", content: "SkillCamp — 짧고 강하게 몰입하는 오프라인 집체교육 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "SkillCamp — 짧고 강하게 몰입하는 오프라인 집체교육 | 코드프레소" },
    { property: "og:description", content: "강사가 이끄는 집합·부트캠프 교육입니다. 실전 미션과 팀 프로젝트를 전문가 피드백으로 다듬으며 실전 역량을 끌어올립니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/skillcamp.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
